export default "__VITE_ASSET__Ckam1a02__"